/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable react/no-array-index-key */
import React, { useCallback, useEffect, useState } from 'react';
import { animateScroll as scroll } from 'react-scroll';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { useForm } from 'react-hook-form';
import { XCircle, MagnifyingGlass } from 'phosphor-react';

import { fetchBibsRacesList, fetchBibsRacesSearch } from '../../../services/apis/business/bibs';

import InputField from '../../../components/fields/input';

import Spinner from '../../../components/loader/spinner';

function BibsRaces() {
  const navigate = useNavigate();

  const [races, setRaces] = useState([]);
  const [searched, setSearched] = useState(false);
  const [fetching, setFetching] = useState(true);

  const { control, watch } = useForm({
    defaultValues: {
      search: '',
    },
  });

  const search = watch('search');

  const racesList = useCallback(async () => {
    setFetching(true);

    try {
      const response = await fetchBibsRacesList();

      const list = response;

      setRaces(list);
      setSearched(false);
      setFetching(false);
    } catch (error) {
      setFetching(false);
    }
  }, []);

  const racesSearch = useCallback(async searchTerm => {
    try {
      const response = await fetchBibsRacesSearch(searchTerm);

      const { races: list } = response;

      setRaces(list);
      setSearched(true);
      setFetching(false);
    } catch (error) {
      setFetching(false);
    }
  }, []);

  const handleSearchKeyDown = useCallback(
    code => {
      if (code === 13) {
        if (search) {
          racesSearch(search);
        } else {
          racesList();
        }
      }
    },
    [search],
  );

  const handleSearchClick = useCallback(() => {
    if (search) {
      racesSearch(search);
    } else {
      racesList();
    }
  }, [search]);

  const handleSearchCancel = useCallback(() => {}, []);

  useEffect(() => {
    racesList();
  }, []);

  useEffect(() => {
    scroll.scrollToTop({
      duration: 0,
      delay: 0,
      smooth: false,
    });
  }, [races]);

  return (
    <>
      <Helmet>
        <title>Bibs Distribution</title>
      </Helmet>
      <div className="min-height">
        <div className="banner">
          <p>Bibs Distribution</p>
        </div>
        <div className="container max-w-4xl mx-auto py-4 px-6 md:px-8">
          <div className="flex flex-col-reverse sm:flex-row justify-evenly sm:justify-between">
            <div className="flex items-center justify-center sm:justify-start">
              {searched && (
                <button
                  type="button"
                  className="button button--text-only !px-0"
                  style={{ marginRight: '10px' }}
                  onClick={() => handleSearchCancel()}>
                  <XCircle size={20} weight="bold" />
                </button>
              )}
              <InputField
                name="search"
                control={control}
                placeholder="Search By Name"
                onKeyDown={event => handleSearchKeyDown(event.keyCode)}
              />
              <button type="button" className="button ml-2" onClick={() => handleSearchClick()}>
                <MagnifyingGlass size={18} weight="bold" />
              </button>
            </div>
          </div>
          {fetching && (
            <div className="mt-8">
              <Spinner size="medium" />
            </div>
          )}
          {!fetching &&
            (races.length > 0 ? (
              <div className="grid grid-cols-12 gap-x-6 gap-y-10 mt-8 mb-6">
                {races.map((race, index) => (
                  <div
                    key={index}
                    className="col-span-6 sm:col-span-3 xl:col-span-3 flex flex-col duration-1000 transition-all cursor-pointer rounded-xl"
                    role="presentation"
                    onClick={() => navigate(`/bibs/dashboard?race=${race.id}`)}>
                    <div className="bg-white flex flex-col h-full shadow-lg rounded-xl relative border border-gray-300 mb-4">
                      <div className="h-full">
                        <LazyLoadImage
                          wrapperClassName="race-logo-wrapper"
                          className="race-logo-image"
                          alt={`${race.name}'s Logo`}
                          effect="blur"
                          src={race.logo}
                        />
                      </div>
                      <div className="text-center pb-4 px-3">
                        <h3 className="text-base font-semibold leading-normal">{race.name}</h3>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <div className="py-8">
                <p className="text-gray-700 text-center">No Races Found</p>
              </div>
            ))}
        </div>
      </div>
    </>
  );
}

export default BibsRaces;
